// NOTICE: KAPTION-INTEGRATION
// Composable for Dashboard App actions triggered by note card resolution.
// Opens the target app tab and sends card data via postMessage.

import { useStore } from 'vuex';
import { useKaptionFeatureFlags } from 'dashboard/composables/useKaptionFeatureFlags';

export function useKaptionNoteCardActions() {
  const store = useStore();
  const { isKaptionFlagEnabled } = useKaptionFeatureFlags();

  const openDashboardApp = (appId, cardData) => {
    const apps = store.getters['dashboardApps/getRecords'];
    const app = apps.find(a => a.id === Number(appId));
    if (!app) return;

    if (app.placement === 'sidebar') {
      const sidebarApps = apps.filter(a => a.placement === 'sidebar');
      const appIndex = sidebarApps.findIndex(a => a.id === app.id);
      const copilotOffset = isKaptionFlagEnabled('KAPTION_COPILOT') ? 2 : 1;
      store.dispatch('updateUISettings', {
        sidebar_app_tab: appIndex + copilotOffset,
      });
    }

    // Send card data to the app via postMessage
    const surface = app.placement === 'sidebar' ? 'sidebar' : 'main';
    const frameId = `dashboard-app--frame-${surface}-${app.id}-0`;
    const frame = document.getElementById(frameId);
    if (frame?.contentWindow) {
      frame.contentWindow.postMessage(
        JSON.stringify({
          type: 'chatwoot-dashboard-note-card-action',
          data: cardData,
        }),
        '*'
      );
    }
  };

  return { openDashboardApp };
}
